import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["availableBlurbs", "writeNewLink", "discardLink"];
  loadingInterval = null;

  // Artificial delay BEFORE fetch (simulate network latency) for testing
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async create(event) {
    event.preventDefault();

    const form = event.target.closest("form");
    if (!form) {
      console.error("Stopset controller: no form found near submit target.");
      return;
    }

    const url = form.action;
    const formData = new FormData(form);

    // Show temporary loading message
    if (this.hasAvailableBlurbsTarget) {
      this.startLoadingAnimation();
    }

    try {
      // TESTING... artificial delay
      // await this.sleep(1500);

      const resp = await fetch(url, {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData
      });

      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const data = await resp.json();

      // Stop animation and display content
      this.stopLoadingAnimation();

      // Optionally simulate post-fetch delay
      // await this.sleep(1000);

      if (this.hasAvailableBlurbsTarget && data.candidate_blurb_html) {
        this.availableBlurbsTarget.innerHTML = data.candidate_blurb_html;
      }

      this.writeNewLinkTarget.innerHTML = data.write_new_blurb_prompt_html;
      this.discardLinkTarget.innerHTML = data.discard_stopset_link_html;

    } catch (err) {
      console.error("Stopset fetch error:", err);
      if (this.hasAvailableBlurbsTarget) {
        this.availableBlurbsTarget.innerHTML = "<p class='text-danger'>Failed to load blurbs.</p>";
      }
    }
  }

  // Animate "Loading..."
  startLoadingAnimation() {
    let dots = 0;
    this.availableBlurbsTarget.textContent = "Loading available blurbs";
    this.loadingInterval = setInterval(() => {
      dots = (dots + 1) % 7; // cycle through 0-6 dots
      this.availableBlurbsTarget.textContent = "Loading available blurbs" + ".".repeat(dots);
    }, 500); // adjust timing here (500ms per dot)
  }

  // Stop animation
  stopLoadingAnimation() {
    if (this.loadingInterval) {
     clearInterval(this.loadingInterval);
     this.loadingInterval = null;
    }
  }
}
